import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import fscreen from 'fscreen';
import uuidv4 from 'uuid/v4';

export default function fullscreenButtonFactory(Button, ReactTooltip) {
  class FullscreenButton extends PureComponent {
    static propTypes = {
      fullscreenElement: PropTypes.instanceOf(Element),
      tooltipEffect: PropTypes.string,
      tooltipPlace: PropTypes.string,
    };

    static defaultProps = {
      fullscreenElement: document.documentElement,
      tooltipEffect: 'solid',
      tooltipPlace: 'left',
    };

    state = {
      tooltipId: uuidv4(),
      isFullscreen: false,
    };

    componentDidMount() {
      if (fscreen.fullscreenEnabled) {
        fscreen.addEventListener(
          'fullscreenchange',
          this.onFullscreenChange,
          false
        );
      }
    }

    componentWillUnmount() {
      if (fscreen.fullscreenEnabled) {
        fscreen.removeEventListener(
          'fullscreenchange',
          this.onFullscreenChange,
          false
        );
      }
    }

    onFullscreenChange = () => {
      this.setState({ isFullscreen: !!fscreen.fullscreenElement });
    };

    toggleFullscreen = () => {
      if (fscreen.fullscreenEnabled) {
        if (this.state.isFullscreen) {
          fscreen.exitFullscreen();
        } else {
          fscreen.requestFullscreen(this.props.fullscreenElement);
        }
      }
    };

    render() {
      const { tooltipId, isFullscreen } = this.state;
      const {
        tooltipPlace,
        tooltipEffect,
        fullscreenElement, // eslint-disable-line no-unused-vars
        ...buttonProps
      } = this.props;

      // eslint-disable-next-line no-nested-ternary
      let tooltip = isFullscreen ? 'Exit Fullscreen' : 'View Fullscreen';
      if (!fscreen.fullscreenEnabled) {
        tooltip = 'Fullscreen mode is not supported by your browser';
      }

      return (
        <div>
          <Button
            {...buttonProps}
            size="sm"
            onClick={this.toggleFullscreen}
            disabled={!fscreen.fullscreenEnabled}
            icon={isFullscreen ? 'compress' : 'expand'}
            data-test-id="fullscreen-button-toggle"
            data-for={tooltipId}
            data-tip={tooltip}
          />

          <ReactTooltip
            id={tooltipId}
            place={tooltipPlace}
            effect={tooltipEffect}
          />
        </div>
      );
    }
  }

  return FullscreenButton;
}
